module.exports = __webpack_public_path__ + "icomoon.1805aa97a0a5da637cdd.ttf";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/nova-icons/icomoon.ttf?1qjem2
// module id = ../../../../../src/assets/custom-styles/fonts/nova-icons/icomoon.ttf?1qjem2
// module chunks = 1